<template>
  <!-- 头部的下载按钮 -->
  <div class="header-download-button-box show-flex-box-c">
    <h3 class="show-flex-box-r">
      <span class="show-flex-box-r">
        <img :src="logoUrl" />
      </span>
      <h5 class="show-flex-box-r">
        <strong>医视屏</strong>
      </h5>
      <div class="download-click-button-box show-flex-box-r show-flex-center" >
        <open-app-button :appParams='appParams' :buttonText="buttonText"/>
      </div>
    </h3>
  </div>
</template>

<script>
import openAppButton from '@/components/common/open_app_button_comp';

export default {
  props: {
    appParams: [String],
    buttonText: {
      type: [String],
      default: '打开APP'
    }
  },
  components: {
    openAppButton
  },
  data() {
    return {
      logoUrl: require('../../assets/basics/logo.png'),
    };
  },
  methods: {
    
  }
};
</script>

<style lang="less">
  .header-download-button-box {
    width: 100%;
    height: 100%;
    > span {
      margin: 0.1rem 0 0.1rem 0.13rem;

      > em {
        height: 0.24rem;
        width: 0.24rem;
        background: url("../../assets/basics/close_page_icon.png") no-repeat
          center center;
        background-size: 100% 100%;
      }
    }

    > h3 {
      padding: 0.05rem 0.15rem;
      flex-grow: 1;
      align-items: center;

      > span {
        height: 0.4rem;
        width: 0.4rem;

        > img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }

      > h5 {
        padding: 0.09rem 0.08rem 0.1rem 0.08rem;
        flex-grow: 1;

        > strong {
          font-size: 0.15rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 0.21rem;
        }
      }

      > .download-click-button-box {
        margin: 0.03rem 0;
        width: 0.8rem;
        height: 0.34rem;
        background: #01A661;
        border-radius: 0.07rem;
        flex-shrink: 0;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/basic/header_download_button.vue